export class ScannerError extends Error {
  constructor(code, message) {
    super(message);
    this.name = "ScannerError";
    this.code = code;
  }
}
